module.exports = __webpack_public_path__ + "media/gaucher.acc61428.mp4";